module.exports = __webpack_public_path__ + "img/Offside.873b721f.png";